import React from 'react'
import PropTypes from 'prop-types'
import { usePersistSchedulingEngineDraft } from '../hooks/usePersistSchedulingEngineDraft'

const PersistSchedulingEngineDraft = ({ instrumentId, dispatch }) => {
  usePersistSchedulingEngineDraft({ instrumentId, dispatch })
  return null
}

PersistSchedulingEngineDraft.propTypes = {
  instrumentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dispatch: PropTypes.func.isRequired,
}

export default PersistSchedulingEngineDraft
